import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import GenericSelect from './GenericSelect'
import Sticker from '../Sticker'

class ColorSelect extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      selected: props.selected || null
    }

    // Bind events
    this.onChangeSelect = this.onChangeSelect.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    // Bubble local change to parent
    if (prevState.selected !== this.state.selected) {
      if (_.isFunction(this.props.onChange)) {
        this.props.onChange(this.state.selected)
      }
    }

    // Bubble parent change to local
    if (prevProps.selected !== this.props.selected) {
      this.setState({
        selected: this.props.selected
      })
    }
  }

  onChangeSelect(selectedStr) {
    const selected = _.isString(selectedStr) ? Number(selectedStr) : selectedStr
    this.setState({
      selected
    })
  }

  render() {
    const { label, loading, options, selected, onChange, error, ...props } = this.props
    return (
      <GenericSelect
        label={label}
        loading={loading}
        options={
          _.map(options, (option) => ({
            key: String(option.id),
            value: (
              <span>
                <Sticker
                  circular={true}
                  foreground={option.foreground}
                  background={option.background}
                  text='A'
                />
                {' '}
                {option.name}
              </span>
            ),
            searchValue: option.name
          }))
        }
        selected={!_.isNull(this.state.selected) ? String(this.state.selected) : null}
        onChange={this.onChangeSelect}
        error={error}
        canSearch={true}
        reducedPadding={true}
        {...props}
      />
    )
  }
}

ColorSelect.propTypes = {
  label: PropTypes.string, // if missing, rendered without Form structure
  loading: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      foreground: PropTypes.string.isRequired,
      background: PropTypes.string.isRequired
    }).isRequired
  ),
  selected: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string
}

export default ColorSelect



// WEBPACK FOOTER //
// ./src/components/elements/forms/ColorSelect.js